/*
 * @Descripttion:
 * @Version: 1.0
 * @Author: 张家彬
 * @Date: 2024-04-29 14:00:18
 * @LastEditors: 张家彬
 * @LastEditTime: 2024-06-11 10:53:25
 */
import { request } from '@umijs/max';

//获取验证码
export const getCodeApi = () => {
  return request('/common/code');
};
//登录
export const userLoginApi = (params) => {
  return request('/manage/user/login', {
    method: 'POST',
    data: params,
  });
};
//修改密码
export const userResetApi = (params) => {
  return request('/manage/user/reset', {
    method: 'POST',
    data: params,
  });
};
